
  import { defineComponent } from 'vue';
  import { mapActions, mapGetters } from 'vuex';

  import InputBlock from '@/common/components/redesigned/InputBlock.vue';
  import SelectMultiComponent from '@/common/components/SelectMultiComponent.vue';

  import { DEFAULT_BASE_FILTER } from '../../constants/constants';
  import { TBaseRegionFilter } from '../../types/common';

  import { DIRECTIVES_ACTIONS_NAME, DIRECTIVES_GETTERS_NAME } from '@/store/directives';

  export default defineComponent({
    name: 'BaseFilterBlock',
    components: {
      InputBlock,
      SelectMultiComponent,
    },
    emits: {
      changeFilter: (value: TBaseRegionFilter) => value,
    },
    props: {
      itemsClass: {
        type: String,
        default: '',
      },
      placeholders: {
        type: Object,
        default: () => ({
          region: 'Выберите',
        }),
      },
    },
    data(): { filter: TBaseRegionFilter } {
      return {
        filter: { ...DEFAULT_BASE_FILTER },
      };
    },

    mounted() {
      this.fetchRegions();
    },

    computed: {
      ...mapGetters({
        getRegionsListWithId: DIRECTIVES_GETTERS_NAME.getRegionsListWithId,
      }),
    },

    methods: {
      ...mapActions({
        fetchRegions: DIRECTIVES_ACTIONS_NAME.getRegions,
      }),
    },

    watch: {
      filter: {
        handler(value: TBaseRegionFilter) {
          this.$emit('changeFilter', value);
        },
        deep: true,
      },
    },
  });
